"use client";

import React from "react";
import styled, { css } from "styled-components";
import { Box, Row } from "@motorata/base-ui.components.atoms._atoms";
import { H1, Label } from "@motorata/base-ui.components.atoms.typography";
import Icon from "@motorata/base-ui.components.atoms.icon";
import Link from "@motorata/next.components.atoms.link";
import { addSpacesFromPhoneNumber } from "@motorata/base-ui.utils.string";
import Image from "../../components/common/Image";

const ProfileHeader = ({ profile }) => {

  const hasBackgroundImage = !!profile.images.background;

  return (
    <Wrapper className="background_white">
      {profile.images.background && (
        <ImageWrapper>
          <ImageContent>
            <Image
              size={1280}
              fill
              src={profile.images.background.src}
              alt={`Zdjęcie w tle ${profile.name}`}
              style={{
                objectFit: "cover"
              }}
            />
          </ImageContent>
        </ImageWrapper>
      )}
      <StyledTitleHeader
        hasBackgroundImage={hasBackgroundImage}
        justifyContent="space-between"
        alignItems="center"
      >
        <ProfileWrapper alignItems="center" hasBackgroundImage={hasBackgroundImage}>
          {profile.images.profile && (
            <ProfileImageWrapper
              hasBackgroundImage={hasBackgroundImage}
              marginLeft={hasBackgroundImage ? "M" : "0"}
              marginRight="M"
              hasBackground={!!profile.images.background}
            >
              <Image
                height={hasBackgroundImage ? 150 : 65}
                width={hasBackgroundImage ? 150 : 65}
                src={profile.images.profile.src}
                alt={`Zdjęcie profilowe ${profile.name}`}
                style={{
                  display: "block",
                  objectFit: "contain"
                }}
              />
            </ProfileImageWrapper>
          )}
          <Box width="100%">
            <Row alignItems="center" marginBottom="XXS">
              <Icon width="15px" marginRight="XS" icon="verified-fill" color="blue" />
              <H1 fontSize="XXL" margin="0">
                {profile.name}
              </H1>
            </Row>
            <Label color="third">@{profile.slug}</Label>
          </Box>
        </ProfileWrapper>
        <ButtonsWrapper>
          {profile.phone && (
            <Link href={`tel:${profile.phone}`} type="secondary" icon="phone-fill" width="max-content">
              {addSpacesFromPhoneNumber(profile.phone)}
            </Link>
          )}
          {profile.website && (
            <Link
              href={`https://${profile.website}`}
              icon="earth-fill"
              width="max-content"
            >
              Zobacz witrynę
            </Link>
          )}
        </ButtonsWrapper>
      </StyledTitleHeader>
    </Wrapper>
  );
};

export default ProfileHeader;

const ButtonsWrapper = styled(Box)`
  display: flex;
  justify-content: flex-end;
  width: max-content;

  >*:last-of-type{
    margin-left: ${({ theme }) => theme.space.S};
  }
  
  @media (max-width: 950px) {
    width: 100%;
    
    >*{
      width: calc((100% / ${({ theme }) => theme.space.S}) / 2);
    }
  }

  @media (max-width: 600px) {
    display: block;
    width: 100%;

    >*{
      width: 100%;
      
      &:last-of-type{
        margin-left: 0;
        margin-top: ${({ theme }) => theme.space.S};
      }
    }
  }
`

const ProfileWrapper = styled(Box)<{
  hasBackgroundImage: boolean
}>`
  display: flex;
  align-items: center;
  width: 100%;

  @media (max-width: 950px) {
    display: flex;
    flex-direction: column;
    margin-bottom: ${({ theme }) => theme.space.S};
  }
`;

const ProfileImageWrapper = styled(Box)<{
  hasBackgroundImage: boolean
}>`
  border-radius: 50%;
  overflow: hidden;
  border: 5px solid white;
  min-width: max-content;
  min-height: max-content;

  ${({ hasBackgroundImage }) => hasBackgroundImage && css`
    margin-top: calc((${({ theme }) => theme.space.M} + 80px) / -1);
  `};

  @media (max-width: 950px) {
    margin-bottom: ${({ theme }) => theme.space.S};
  }
`;

const StyledTitleHeader = styled(Row)<{
  hasBackgroundImage: boolean
}>`
  padding: ${({ theme }) => theme.space.M} 0;

  @media (max-width: 950px) {
    display: flex;
    flex-direction: column;
  }
`;

const ImageContent = styled(Box)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

const ImageWrapper = styled(Box)`
  width: 100%;
  padding-bottom: 30%;
  border-radius: 10px;
  overflow: hidden;

  @media (max-width: 800px) {
    min-height: 200px;
  }
`;

const Wrapper = styled(Box)`
  &::before {
    height: 100vh !important;
    bottom: 0 !important;
    top: auto !important;
  }
`;
